export default function AuditStart() {
  return (
    <div style={{ maxWidth: 560, margin: '80px auto', textAlign: 'center', padding: 24 }}>
      <h1>Auditez votre compte Google Ads gratuitement</h1>
      <p>Connectez votre compte en lecture seule — vous recevez un rapport d'audit en quelques minutes.</p>
      <a
        href="/api/public-audit/start"
        style={{
          display: 'inline-block', marginTop: 24, padding: '14px 32px',
          background: 'linear-gradient(135deg,#ff6d11,#fc1cc7)', color: '#fff',
          borderRadius: 50, textDecoration: 'none', fontWeight: 600,
        }}
      >
        Connecter mon compte Google Ads
      </a>
      <p style={{ marginTop: 16, fontSize: 12, color: '#94a3b8' }}>
        Nous n'effectuons jamais aucune modification sur votre compte : uniquement une analyse, jamais une action.
      </p>
    </div>
  )
}
